import { forwardRef } from 'react';

import { Link, LinkProps } from '@backstage/core-components';

import {
  Link as EncoreLink,
  type LinkProps as EncoreLinkProps,
  VisuallyHidden,
} from '@spotify-internal/encore-web';

import { useConfidenceUrl } from '../../hooks';

export const ConfidenceWebsiteLink = forwardRef<
  HTMLAnchorElement,
  Omit<LinkProps, 'to' | 'href'> & { route?: string }
>(({ route = '', target = '_blank', ...props }, ref) => {
  const url = useConfidenceUrl(route);
  return <Link {...props} to={url.href} target={target} ref={ref} />;
});
ConfidenceWebsiteLink.displayName = 'ConfidenceWebsiteLink';

export const ConfidenceWebsiteLinkEncore = forwardRef<
  HTMLAnchorElement,
  Omit<EncoreLinkProps, 'href'> & { route?: string }
>(
  (
    {
      children,
      route = '',
      target = '_blank',
      rel = 'noopener noreferrer',
      ...props
    },
    ref,
  ) => {
    const url = useConfidenceUrl(route);
    return (
      <EncoreLink
        {...props}
        href={url.href}
        target={target}
        rel={rel}
        ref={ref}
      >
        {children}
        {target === '_blank' && (
          <>
            {' '}
            <VisuallyHidden>(opens in new window)</VisuallyHidden>
          </>
        )}
      </EncoreLink>
    );
  },
);
ConfidenceWebsiteLinkEncore.displayName = 'ConfidenceWebsiteLinkEncore';
